import { render, staticRenderFns } from "./wuliu.vue?vue&type=template&id=5612d822&"
import script from "./wuliu.vue?vue&type=script&lang=js&"
export * from "./wuliu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports